import { ACTIONS } from "./actions";

const initialState = {
  adDate: "",
  kpiDate: "",
  adStackedBarChartInfo: {},
  tunnelUsageType: "topTunnel",
  adUsageDate: "",
  cellularInterfaceProps: {},
  selectedtrendCircuits: [], // for availability and usage trend
  circuitTrendList: [], // for availability and usage trend
  prevCircuitUsageList: [], // for circuit usage list
  appUsageList: [], // for application usage list
  prevAppUsageList: [], // for application usage list
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case ACTIONS.PREV_APP_USG_LIST:
      return {
        ...state,
        prevAppUsageList: payload
      };
    case ACTIONS.APP_USG_LIST:
      return {
        ...state,
        appUsageList: payload
      };
    case ACTIONS.PREV_SELEC_USG_CIRCUITS:
      return {
        ...state,
        prevCircuitUsageList: payload
      };
    case ACTIONS.LATEST_SELEC_TREND_CIRCUITS:
      return {
        ...state,
        circuitTrendList: payload
      };
    case ACTIONS.GET_SELEC_TREND_CIRCUITS:
      return {
        ...state,
        selectedtrendCircuits: payload
      };
    case ACTIONS.GET_USAGE_CIP_PROPS:
      return {
        ...state,
        cellularInterfaceProps: payload
      };
    case ACTIONS.GET_USAGE_AD_DATE:
      return {
        ...state,
        adUsageDate: payload,
        cellularInterfaceProps: {},
        selectedtrendCircuits: [],
        circuitTrendList: [],
      };
    case ACTIONS.GET_AD_DATE:
      return {
        ...state,
        adDate: payload,
        kpiDate: payload
      };
    case ACTIONS.GET_KPI_DATE:
      return {
        ...state,
        kpiDate: payload
      };
    case ACTIONS.GET_BAR_CHART_DATE:
      return {
        ...state,
        adStackedBarChartInfo: payload
      };
    case ACTIONS.UPDATE_USAGE_TYPE:
      return {
        ...state,
        tunnelUsageType: payload
      };
    default:
      return state;
  }
};

export default reducer;
